<template>
  <section v-if="mng" id="CRM">
    <modal size="fluid" v-if="showCRM && !loading" @close="$emit('hideCRM')">
      <modal-header>
        <modal-title><b>{{ selectedContragentDescription }}</b> - анализ клиента</modal-title>
      </modal-header>
    <modal-body>
    <template>
    <section class="mt-3">
      <row>
          <column xl="3" md="6" class="mb-1">
          <card cascade class="cascading-admin-card">
            <div class="admin-up" title="ABC-классификация основана на правиле Парето:
            20 % клиентов обеспечивают 80 % выручки (и наоборот, 80 % клиентов обеспечивают лишь 20 % выручки).
            АВС-классификация позволяет разбить клиентов на три группы важности:
            - Высокая (класс 'А')
            - Средняя (класс 'В')
            - Низкая (класс 'С')">
              <fa icon="money" v-bind:class = "{ 'success-color': partnerABCXYZ[0].Класс === 'AКласс', 'info-color': partnerABCXYZ[0].Класс === 'BКласс', 'warning-color': partnerABCXYZ[0].Класс === 'CКласс', 'danger-color': partnerABCXYZ[0].Класс === 'НеКлассифицирован' }"/>
              <div class="data">
                <p>{{partnerABCXYZ[0].ТипКлассификации}} - {{partnerABCXYZ[0].ТипПараметраКлассификации}}</p>
                <h4>
                  <strong>€{{partnerABCXYZ[0].ЗначениеПараметраКлассификации}}</strong>
                </h4>
              </div>
            </div>
            <card-body>
              <div class="progress">
                <div aria-valuemax="100" aria-valuemin="0" v-bind:aria-valuenow="{'25':partnerABCXYZ[1].ЗначениеПараметраКлассификации < 50, '50':partnerABCXYZ[1].ЗначениеПараметраКлассификации > 50 && partnerABCXYZ[1].ЗначениеПараметраКлассификации < 120, '100':partnerABCXYZ[1].ЗначениеПараметраКлассификации > 120  }" class="progress-bar bg grey darken-2" role="progressbar"
                  v-bind:style="{'width':partnerABCXYZ[1].ЗначениеПараметраКлассификации+'%'}"></div>
              </div>
              <card-text>{{partnerABCXYZ[0].Класс}}</card-text>
            </card-body>
          </card>
        </column>
        <column xl="3" md="6" class="mb-1">
          <card cascade class="cascading-admin-card">
            <div class="admin-up" title="В дополнение к АВС-классификации можно классифицировать контрагентов по стадиям отношений.
            Для стадии 'Постоянный клиент' предусмотренная дополнительная классификация по регулярности закупок:
            - стабильные закупки (X-класс)
            - нерегулярные закупки (Y-класс)
            - эпизодические закупки (Z-класс)">
              <fa icon="pie-chart" v-bind:class = "{ 'success-color': partnerABCXYZ[1].Класс === 'XКласс', 'info-color': partnerABCXYZ[1].Класс === 'YКласс', 'warning-color': partnerABCXYZ[1].Класс === 'ZКласс', 'danger-color': partnerABCXYZ[1].Класс === 'НеКлассифицирован' }"/>
              <div class="data">
                <p>{{partnerABCXYZ[1].ТипКлассификации}} - {{partnerABCXYZ[1].ТипПараметраКлассификации}}</p>
                <h4>
                  <strong>{{partnerABCXYZ[1].ЗначениеПараметраКлассификации}}</strong>
                </h4>
              </div>
            </div>
            <card-body>
              <div class="progress">
                <div aria-valuemax="100" aria-valuemin="0" v-bind:aria-valuenow="{'25':partnerABCXYZ[1].ЗначениеПараметраКлассификации < 50, '50':partnerABCXYZ[1].ЗначениеПараметраКлассификации > 50 && partnerABCXYZ[1].ЗначениеПараметраКлассификации < 120, '100':partnerABCXYZ[1].ЗначениеПараметраКлассификации > 120  }" class="progress-bar bg grey darken-2" role="progressbar"
                  v-bind:style="{'width':partnerABCXYZ[1].ЗначениеПараметраКлассификации+'%'}"></div>
              </div>
              <card-text>{{partnerABCXYZ[1].Класс}}</card-text>
            </card-body>
          </card>
        </column>
        <column xl="3" md="6" class="mb-1">
          <card cascade class="cascading-admin-card">
            <div class="admin-up" title="ABC-классификация основана на правиле Парето:
            20 % клиентов обеспечивают 80 % выручки (и наоборот, 80 % клиентов обеспечивают лишь 20 % выручки).
            АВС-классификация позволяет разбить клиентов на три группы важности:
            - Высокая (класс 'А')
            - Средняя (класс 'В')
            - Низкая (класс 'С')">
              <fa icon="money" v-bind:class = "{ 'success-color': partnerABCXYZ[2].Класс === 'AКласс', 'info-color': partnerABCXYZ[2].Класс === 'BКласс', 'warning-color': partnerABCXYZ[2].Класс === 'CКласс', 'danger-color': partnerABCXYZ[2].Класс === 'НеКлассифицирован' }"/>
              <div class="data">
                <p>{{partnerABCXYZ[2].ТипКлассификации}} - {{partnerABCXYZ[2].ТипПараметраКлассификации}}</p>
                <h4>
                  <strong>€{{partnerABCXYZ[2].ЗначениеПараметраКлассификации}}</strong>
                </h4>
              </div>
            </div>
            <card-body>
              <div class="progress">
                 <div aria-valuemax="100" aria-valuemin="0" v-bind:aria-valuenow="{'25':partnerABCXYZ[3].ЗначениеПараметраКлассификации < 50, '50':partnerABCXYZ[3].ЗначениеПараметраКлассификации > 50 && partnerABCXYZ[3].ЗначениеПараметраКлассификации < 120, '100':partnerABCXYZ[3].ЗначениеПараметраКлассификации > 120  }" class="progress-bar bg grey darken-2" role="progressbar"
                  v-bind:style="{'width':partnerABCXYZ[3].ЗначениеПараметраКлассификации+'%'}"></div>
              </div>
              <card-text>{{partnerABCXYZ[2].Класс}}</card-text>
            </card-body>
          </card>
        </column>
        <column xl="3" md="6" class="mb-1">
          <card cascade class="cascading-admin-card">
            <div class="admin-up" title="В дополнение к АВС-классификации можно классифицировать контрагентов по стадиям отношений.
            Для стадии 'Постоянный клиент' предусмотренная дополнительная классификация по регулярности закупок:
            - стабильные закупки (X-класс)
            - нерегулярные закупки (Y-класс)
            - эпизодические закупки (Z-класс)">
              <fa icon="pie-chart" v-bind:class = "{ 'success-color': partnerABCXYZ[3].Класс === 'XКласс', 'info-color': partnerABCXYZ[3].Класс === 'YКласс', 'warning-color': partnerABCXYZ[3].Класс === 'ZКласс', 'danger-color': partnerABCXYZ[3].Класс === 'НеКлассифицирован' }"/>
              <div class="data">
                <p>{{partnerABCXYZ[3].ТипКлассификации}} - {{partnerABCXYZ[3].ТипПараметраКлассификации}}</p>
                <h4>
                  <strong>{{partnerABCXYZ[3].ЗначениеПараметраКлассификации}}</strong>
                </h4>
              </div>
            </div>
            <card-body>
              <div class="progress">
                <div aria-valuemax="100" aria-valuemin="0" v-bind:aria-valuenow="{'25':partnerABCXYZ[3].ЗначениеПараметраКлассификации < 50, '50':partnerABCXYZ[3].ЗначениеПараметраКлассификации > 50 && partnerABCXYZ[3].ЗначениеПараметраКлассификации < 120, '100':partnerABCXYZ[3].ЗначениеПараметраКлассификации > 120  }" class="progress-bar bg grey darken-2" role="progressbar"
                  v-bind:style="{'width':partnerABCXYZ[3].ЗначениеПараметраКлассификации+'%'}"></div>
              </div>
              <card-text>{{partnerABCXYZ[3].Класс}}</card-text>
            </card-body>
          </card>
        </column>
        </row>
    </section>
    </template>
    <section>
    <template>
      <row class="mt-2">
          <column md="12" lg="6" class="mb-1">
              <card>
                 <card-header> Продажи по месяцам, € </card-header>
                  <card-body>
                      <div style="display: block">
                        <bar-chart :data="barChartData" :options="barChartOptions" :height="200" key="user.Ref_Key"></bar-chart>
                      </div>
                  </card-body>
              </card>
          </column>
          <column md="12" lg="6" class="mb-1">
              <card class="mb-1">
             <card-header> Продажи за период с нарастающим итогом, € </card-header>
            <card-body>
              <div style="display: block">
                <line-chart ref="lineChart" :data="lineChartData" :options="lineChartOptions" :height="200"></line-chart>
              </div>
            </card-body>
          </card>
          </column>
        </row>
    </template>
    </section>
    <section>
    <row class="mt-3">
        <column md="1" lg="4" class="mb-0">
          <card class="mb-0">
            <card-header> {{years[0]}} Группы товаров </card-header>
            <card-body>
              <div style="display: block">
                <doughnut-chart :data="doughnutChartData0" :options="doughnutChartOptions0" :height="300"></doughnut-chart>
              </div>
            </card-body>
          </card>
        </column>
        <column md="1" lg="4" class="mb-0">
          <card class="mb-0">
            <card-header> {{years[1]}} Группы товаров </card-header>
            <card-body>
              <div style="display: block">
                <doughnut-chart :data="doughnutChartData1" :options="doughnutChartOptions1" :height="300"></doughnut-chart>
              </div>
            </card-body>
          </card>
        </column>
        <column md="1" lg="4" class="mb-0">
          <card class="mb-0">
            <card-header> {{years[2]}} Группы товаров </card-header>
            <card-body>
              <div style="display: block">
                <doughnut-chart :data="doughnutChartData2" :options="doughnutChartOptions2" :height="300"></doughnut-chart>
              </div>
            </card-body>
          </card>
        </column>
      </row>
    <section>
      <row>
      <column xl="4">
               <card class="mb-4">
                  <card-body>
                      <list-group class="list-group-flush">
                          <list-group-item v-for="(value, k) in partnerSalesByGroupsExport[0]" :key="k" action waves>{{k}}
                              <badge v-if="partnerSalesByGroupsExport[0][k] === partnerSalesByGroupsExport[1][k]" color="primary-color" pill class="pull-right">{{value}} </badge>
                              <badge v-if="partnerSalesByGroupsExport[0][k] > partnerSalesByGroupsExport[1][k]" color="success-color" pill class="pull-right">{{value}} <fa icon="arrow-up" class="ml-1"/></badge>
                              <badge v-if="partnerSalesByGroupsExport[0][k] < partnerSalesByGroupsExport[1][k]" color="danger-color" pill class="pull-right">{{value}} <fa icon="arrow-down" class="n ml-1"/> </badge>
                          </list-group-item>
                      </list-group>
                  </card-body>
              </card>
       </column>
       <column xl="4">
               <card class="mb-4">
                  <card-body>
                      <list-group class="list-group-flush">
                          <list-group-item v-for="(value, k) in partnerSalesByGroupsExport[1]" :key="k" action waves>{{k}}
                              <badge v-if="partnerSalesByGroupsExport[1][k] === partnerSalesByGroupsExport[2][k]" color="primary-color" pill class="pull-right">{{value}} </badge>
                              <badge v-if="partnerSalesByGroupsExport[1][k] > partnerSalesByGroupsExport[2][k]" color="success-color" pill class="pull-right">{{value}} <fa icon="arrow-up" class="ml-1"/></badge>
                              <badge v-if="partnerSalesByGroupsExport[1][k] < partnerSalesByGroupsExport[2][k]" color="danger-color" pill class="pull-right">{{value}} <fa icon="arrow-down" class="n ml-1"/> </badge>
                          </list-group-item>
                      </list-group>
                  </card-body>
              </card>
       </column>
      <column xl="4">
               <card class="mb-4">
                  <card-body>
                      <list-group class="list-group-flush">
                          <list-group-item v-for="(value, k) in partnerSalesByGroupsExport[2]" :key="k" action waves>{{k}}
                              <badge color="primary-color" pill class="pull-right">{{value}}
                              </badge>
                          </list-group-item>
                      </list-group>
                  </card-body>
              </card>
       </column>
      </row>
     </section>
    <row>
        <column md="6" class="mb-4">
            <card>
            <card-header>
              {{years[0]}} -   Топ 100 товаров
            </card-header>
            <card-body>
              <mdb-datatable
                :data="tabledata"
                striped
                bordered
                responsive
                :order="[0, 'dec']"
               />
              </card-body>
            </card>
          </column>
          <column md="6" class="mb-4">
              <card>
              <card-header>
              {{years[1]}} -   Топ 100 товаров
            </card-header>
                  <card-body>
                 <mdb-datatable
                :data="tabledata1"
                striped
                bordered
                responsive
                :order="[0, 'dec']"
                />
               </card-body>
              </card>
          </column>
      </row>
    </section>
   </modal-body>
   <modal-footer>
     <btn color="secondary" @click.native="$emit('hideCRM')">Закрыть</btn>
  </modal-footer>
  </modal>
  </section>
</template>

<script>
import { Row, Column, Btn, Card, CardBody, CardHeader, CardText, Fa, BarChart, PieChart, LineChart, RadarChart, DoughnutChart, ListGroup, ListGroupItem, Badge, Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, mdbDatatable } from 'mdbvue'
// import {eventBus} from '../main'
export default {
  name: 'CRM',
  components: {
    Row,
    Column,
    Btn,
    Card,
    CardBody,
    CardHeader,
    CardText,
    Fa,
    BarChart,
    PieChart,
    LineChart,
    RadarChart,
    DoughnutChart,
    ListGroup,
    ListGroupItem,
    Badge,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    mdbDatatable
  },
  props: ['showCRM', 'loading', 'authorized', 'user', 'goods', 'orders', 'mng', 'накладные', 'partnerABCXYZ', 'partnerSales', 'partnerSalesTotal', 'partnerSalesByGoodsExport', 'partnerSalesByGroupsExport', 'selectedContragentDescription'],
  data () {
    return {
      showChart: true,
      closeright: false,
      closeleft: false,
      years: [],
      tabledata: {
        columns: [
          {
            label: 'Выручка,€',
            field: 'Sales',
            sort: 'asc'
          },
          {
            label: 'Наименование',
            field: 'Name',
            sort: 'asc'
          }
        ],
        rows: this.partnerSalesByGoodsExport[0]
      },
      tabledata1: {
        columns: [
          {
            label: 'Выручка,€',
            field: 'Sales',
            sort: 'asc'
          },
          {
            label: 'Наименование',
            field: 'Name',
            sort: 'asc'
          }
        ],
        rows: this.partnerSalesByGoodsExport[1]
      },
      barChartData: {
        labels: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        datasets: [
          {
            label: 'this.years[0]',
            data: this.partnerSales[0],
            backgroundColor: 'rgba(245, 74, 85, 0.5)',
            borderWidth: 1
          },
          {
            label: 'this.years[1]',
            data: this.partnerSales[1],
            backgroundColor: 'rgba(245, 192, 50, 0.5)',
            borderWidth: 1
          }, {
            label: 'this.years[2]',
            data: this.partnerSales[2],
            backgroundColor: 'rgba(90, 173, 246, 0.5)',
            borderWidth: 1
          }
        ]
      },
      barChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            barPercentage: 1,
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            },
            ticks: {
              beginAtZero: true
            }
          }]
        }
      },
      lineChartData: {
        labels: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        datasets: [
          {
            label: 'this.years[0]',
            backgroundColor: 'rgba(245, 74, 85, 0.5)',
            data: this.partnerSalesTotal[0]
          },
          {
            label: 'this.years[1]',
            backgroundColor: 'rgba(245, 192, 50, 0.5)',
            data: this.partnerSalesTotal[1]
          },
          {
            label: 'this.years[2]',
            backgroundColor: 'rgba(90, 173, 246, 0.5)',
            data: this.partnerSalesTotal[2]
          }
        ]
      },
      lineChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }]
        }
      },
      doughnutChartData0: {
        labels: Object.keys(this.partnerSalesByGroupsExport[0]),
        datasets: [
          {
            data: Object.values(this.partnerSalesByGroupsExport[0]),
            backgroundColor: ['#212121', '#FDB45C', '#F7464A', '#46BFBD', '#0099CC', '#007E33', '#9933CC', '#795548'],
            hoverBackgroundColor: ['#2E2E2E', '#FFC870', '#FF5A5E', '#5AD3D1', '#33b5e5', '#00C851', '#aa66cc', '#bcaaa4']
          }
        ]
      },
      doughnutChartOptions0: {
        responsive: true,
        maintainAspectRatio: false
      },
      doughnutChartData1: {
        labels: Object.keys(this.partnerSalesByGroupsExport[1]),
        datasets: [
          {
            data: Object.values(this.partnerSalesByGroupsExport[1]),
            backgroundColor: ['#212121', '#FDB45C', '#F7464A', '#46BFBD', '#0099CC', '#007E33', '#9933CC', '#795548'],
            hoverBackgroundColor: ['#2E2E2E', '#FFC870', '#FF5A5E', '#5AD3D1', '#33b5e5', '#00C851', '#aa66cc', '#bcaaa4']
          }
        ]
      },
      doughnutChartOptions1: {
        responsive: true,
        maintainAspectRatio: false
      },
      doughnutChartData2: {
        labels: Object.keys(this.partnerSalesByGroupsExport[2]),
        datasets: [
          {
            data: Object.values(this.partnerSalesByGroupsExport[2]),
            backgroundColor: ['#212121', '#FDB45C', '#F7464A', '#46BFBD', '#0099CC', '#007E33', '#9933CC', '#795548'],
            hoverBackgroundColor: ['#2E2E2E', '#FFC870', '#FF5A5E', '#5AD3D1', '#33b5e5', '#00C851', '#aa66cc', '#bcaaa4']
          }
        ]
      },
      doughnutChartOptions2: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  methods: {
    /*
    upd: function () {
      console.log('update function')
      this.barChartData.datasets[0].data = this.partnerSales[0]
      this.barChartData.datasets[1].data = this.partnerSales[1]
      this.barChartData.datasets[2].data = this.partnerSales[2]
      this.lineChartData.datasets[0].data = this.partnerSales[0]
      this.lineChartData.datasets[1].data = this.partnerSales[1]
      this.lineChartData.datasets[2].data = this.partnerSales[2]
      this.tabledata.rows = this.partnerSalesByGoodsExport[0]
      this.tabledata1.rows = this.partnerSalesByGoodsExport[1]
      this.showChart = true
    },
    hid: function () {
      console.log('hide function')
      this.showChart = false
    },
    zero: function () {
      this.barChartData.datasets[0].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.barChartData.datasets[1].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.barChartData.datasets[2].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.lineChartData.datasets[0].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.lineChartData.datasets[1].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.lineChartData.datasets[2].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.tabledata.rows = []
      this.tabledata1.rows = []
    },
    */
    year: function () {
      var date = new Date()
      var year = date.getFullYear().toString()
      this.years[0] = year - 1 + 1
      this.years[1] = year - 1
      this.years[2] = year - 2
      this.barChartData.datasets[0].label = this.years[0]
      this.barChartData.datasets[1].label = this.years[1]
      this.barChartData.datasets[2].label = this.years[2]
      this.lineChartData.datasets[0].label = this.years[0]
      this.lineChartData.datasets[1].label = this.years[1]
      this.lineChartData.datasets[2].label = this.years[2]
    }
  },
  beforeMount () {
  },
  mounted: function () {
    this.year()
  },
  beforeUpdate: function () {
  },
  updated () {
    // this.$bus.$emit('upd')
    this.year()
    // this.upd()
    // console.log('updated property')
  },
  created: function () {
    // this.$bus.$on('Contragent', this.zero)
    // this.$bus.$on('partnerSalesByYear', this.hid)
    // this.$bus.$on('partnerSalesByYear', this.upd)
    this.year()
  },
  beforedestroy: function () {
    // this.$bus.$off('Contragent')
    // this.$bus.$off('partnerSalesByYear')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cascading-admin-card {
  margin: 20px 0;
}
.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
}
.cascading-admin-card .admin-up .fa {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 13px 0 rgba(0, 0, 0, 0.19);
}
.cascading-admin-card .admin-up .fa {
  padding: 1.7rem;
  font-size: 2rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
}
.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}
.admin-up .data p {
  color: #999999;
  font-size: 12px;
}
.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}
.classic-admin-card .card-body p {
  font-size: 13px;
  opacity: 0.7;
  margin-bottom: 0;
}
.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/CRM.vue